import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center mt-10 mt-lg-0" };
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_6 = { class: "table-responsive" };
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = {
    colspan: "5",
    class: "text-center py-4"
};
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" };
const _hoisted_11 = { class: "d-flex align-items-center" };
const _hoisted_12 = ["src"];
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_14 = { class: "d-block mb-1" };
const _hoisted_15 = { class: "text-muted" };
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-end pe-0" };
const _hoisted_18 = { class: "dropdown" };
const _hoisted_19 = { class: "dropdown-menu" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 2 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button"
                }, [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Nouvel article ", -1),
                        _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                    ]))])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", {
                    class: "search-box position-relative me-15",
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
                }, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                        type: "text",
                        class: "form-control shadow-none text-black rounded-0 border-0",
                        placeholder: "Rechercher un article..."
                    }, null, 512), [
                        [_vModelText, _ctx.searchQuery]
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("button", {
                        type: "submit",
                        class: "bg-transparent text-primary transition p-0 border-0"
                    }, [
                        _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                    ], -1))
                ], 32),
                _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none rounded-0",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.filterStatus) = $event))
                }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("option", { value: "" }, "Tous les statuts", -1),
                        _createElementVNode("option", { value: "PUBLISHED" }, "Publiés", -1),
                        _createElementVNode("option", { value: "DRAFT" }, "Brouillons", -1)
                    ]))], 512), [
                    [_vModelSelect, _ctx.filterStatus]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                    _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Image"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Titre"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Date"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Statut"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                            }, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                _createElementVNode("td", _hoisted_9, [
                                    _createVNode(_component_LoaderComponent)
                                ])
                            ]))
                            : (_ctx.filteredPosts.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredPosts, (post) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: post.id
                                    }, [
                                        _createElementVNode("td", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("img", {
                                                    src: post.imageUrl || require('@/assets/images/icon/jpg.png'),
                                                    class: "rounded-1 me-8",
                                                    width: "40",
                                                    height: "40",
                                                    alt: "post"
                                                }, null, 8, _hoisted_12)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(post.title), 1),
                                            _createElementVNode("small", _hoisted_15, "/" + _toDisplayString(post.slug), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatDate(post.publishedAt || post.created_at)), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["badge", post.status === 'PUBLISHED' ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning'])
                                            }, _toDisplayString(post.status === 'PUBLISHED' ? 'Publié' : 'Brouillon'), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _cache[9] || (_cache[9] = _createElementVNode("button", {
                                                    class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown"
                                                }, [
                                                    _createElementVNode("i", { class: "flaticon-dots" })
                                                ], -1)),
                                                _createElementVNode("ul", _hoisted_19, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.editPost(post))
                                                        }, [...(_cache[7] || (_cache[7] = [
                                                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Editer ", -1)
                                                            ]))], 8, _hoisted_20)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center text-danger",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.confirmDelete(post))
                                                        }, [...(_cache[8] || (_cache[8] = [
                                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Supprimer ", -1)
                                                            ]))], 8, _hoisted_21)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("td", {
                                            colspan: "5",
                                            class: "text-center py-4 text-muted"
                                        }, "Aucun article trouvé.", -1)
                                    ]))]))
                    ])
                ])
            ])
        ])
    ]));
}
